/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PublishinghousesQueryResponse } from '../../types/GetV1Publishinghouses.ts'

export const getV1PublishinghousesQueryKey = () => [{ url: '/v1/PublishingHouses' }] as const

export type GetV1PublishinghousesQueryKey = ReturnType<typeof getV1PublishinghousesQueryKey>

/**
 * {@link /v1/PublishingHouses}
 */
export async function getV1Publishinghouses(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1PublishinghousesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/PublishingHouses`, ...requestConfig })
    return res
}

export function getV1PublishinghousesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PublishinghousesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PublishinghousesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PublishinghousesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Publishinghouses(config)
        },
    })
}

/**
 * {@link /v1/PublishingHouses}
 */
export function useGetV1Publishinghouses<
    TData = ResponseConfig<GetV1PublishinghousesQueryResponse>,
    TQueryData = ResponseConfig<GetV1PublishinghousesQueryResponse>,
    TQueryKey extends QueryKey = GetV1PublishinghousesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PublishinghousesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PublishinghousesQueryKey()

    const query = useQuery(
        {
            ...getV1PublishinghousesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
